// import { win } from "src/global";
// import getValuesFromJDiwork from "src/workbench-custom/get-values-form-jdiwork";
import { isWorkbench } from ".";

/**
 * 获取页面当前页签名称
 */
export default (): string => {
  // 工作台页签名称
  if(isWorkbench()) {
    try {
      const workbenchNavContainer = window.top.document.querySelector('#workbench-nav-container');
      if(workbenchNavContainer) {
        const pageTabEl = workbenchNavContainer.querySelector('.active') as HTMLElement;
        const pageTabTitle = pageTabEl?.innerText;
        return pageTabTitle || '首页';
      }
    } catch (error) {
      hbLogger.warn(error);
    }
  }

  return '';
}
